import React, { useEffect, useState } from 'react'

import profileActions from 'models/ProfileInfo/actions'
import redemptionsActions from 'models/Redemptions/actions'
import rewardsActions from 'models/Rewards/actions'

import ScreenContainer from 'components/ScreenContainer'

import { EVENT_TYPE } from 'resources'

import { sendAnalyticsEvent } from 'services/analytics'
import usePromiseDispatch from 'hooks/usePromiseDispatch'

import RedemptionStoreHeader from './RedemptionStoreHeader'
import RewardsCategories from './RewardsCategories'

const RedemptionStore = () => {
  const promiseDispatch = usePromiseDispatch()

  const [promptUserRefresh, setPromptUserRefresh] = useState(false)

  useEffect(() => {
    sendAnalyticsEvent(EVENT_TYPE.storeView)
  }, [])

  // Fetch profile info for balance, redemption options for eligibility, and rewards info to display
  useEffect(() => {
    const loadData = async () => {
      const [, tremendousRedemptionOptionsResult] = await Promise.allSettled([
        promiseDispatch(profileActions.fetchProfileInfo.init),
        promiseDispatch(redemptionsActions.fetchTremendousRedemptionOptions.init),
        promiseDispatch(rewardsActions.fetchRedemptionGoal.init),
        promiseDispatch(rewardsActions.fetchAll.init),
      ])

      if (tremendousRedemptionOptionsResult.status === 'rejected') {
        setPromptUserRefresh(true)
      }
    }

    loadData()
  }, [promiseDispatch])

  return (
    <>
      <RedemptionStoreHeader promptUserRefresh={promptUserRefresh} />
      <ScreenContainer>
        <RewardsCategories />
      </ScreenContainer>
    </>
  )
}

export default RedemptionStore
